import VrBank from "./VrBank.container";

export default VrBank;
